import { NgModule } from '@angular/core';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { NbIconModule } from '@nebular/theme';
import { CommonModule } from '@angular/common';
import { TyaIconComponent } from './tya-icon.component';

@NgModule({
  declarations: [TyaIconComponent],
  imports: [
    CommonModule,
    NbEvaIconsModule,
    NbIconModule,
  ],
  exports: [TyaIconComponent],
})
export class TyaIconModule {}
